import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/'
import store from './store'
import config from './config/'
import {i18n} from './plugins/index';

// Router Hook
router.beforeEach((to, from, next) => {
    const user = store.getters['user/user'];
    //检查身份
    if (to.meta && to.meta.public) {
        // 公开的，直接就next了。
        next();
    } else {
        const time = new Date().getTime();
        if (!user.token || (time - user.time) / 1000 >= 3600) {
            //没有token的话，必须跳转到sign-in
            next({name: 'sign-in', query: {_t: encodeURIComponent(to.path)}});
        } else {
            // 判断级别
            const role_level = parseInt(user.role_level);
            let can = true;
            for (let i = 0; i < to.matched.length; i++) {
                const route = to.matched[i];
                //对每一层的目录都要过滤一下，看看能不能访问
                if (route.meta && route.meta.level) {
                    can = route.meta.level.indexOf(role_level) !== -1
                }
            }
            if (!can) {
                next({path: '/'});
            } else {
                const user = store.state.user;
                if (to.name !== "我的档案" && (
                    (!user.email || !user.name || user.name === '' || user.email === ''))) {
                    next({path: '/profile'});
                } else {
                    next();
                }
            }
        }
    }
});

router.afterEach(() => {
});

Vue.config.productionTip = false;
Vue.prototype.$organization = config.org;

//const app =
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

//load preset
/*
app.$api('User.Preset',{},1).then(res=>{
    store.commit('preset/set',res.data.data);
});
*/

store.dispatch('preset/loadPreset');


